import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    refreshSlotList: false,
    totalSlots: 0,
    isDeleteSlot: false
};

/**
 * Redux slice for managing counter-related state.
 *
 * @name siteAuditSlice
 * @type {Slice}
 */
// Action functions declaration
export const userManagementSlice = createSlice({
  name: 'userManagement',
  initialState,
  reducers: {
    /**
     * Set the details of all sites.
     *
     * @function
     * @name setShowSection
     * @param {Object} state - The current state.
     * @param {Object} actions - The action with payload.
     */
    setRefreshSlotList: (state, action) => {
        // Add a new reducer to set itemId
        state.refreshSlotList = action.payload;
    },
    setTotalSlots: (state, action) => {
        // Add a new reducer to set itemId
        state.totalSlots = action.payload;
    },
    setIsDeleteSlot: (state, action) => {
        // Add a new reducer to set itemId
        state.isDeleteSlot = action.payload;
    },    
    userManagementCleanupInitialState: () => initialState  
    }  
});

// Action creators are generated for each case reducer function
export const {
    setRefreshSlotList,
    setTotalSlots,
    setIsDeleteSlot
} = userManagementSlice.actions;

export default userManagementSlice.reducer;
